import { render } from "./RegistosNotariadoView.vue?vue&type=template&id=7b85ce55&scoped=true"
import script from "./RegistosNotariadoView.vue?vue&type=script&lang=js"
export * from "./RegistosNotariadoView.vue?vue&type=script&lang=js"

import "./RegistosNotariadoView.vue?vue&type=style&index=0&id=7b85ce55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b85ce55"]])

export default __exports__